










import { Component, Prop, Vue } from 'vue-property-decorator';
import * as Common from '@/tenant/common';

@Component
export default class TradeSideBar extends Vue {

  public countReceive:number = null;
  public countSend:number= null;

  public created() {
    this.$api.addEventListener('workflow',this.reload);
  }
  public destroyed() {
    this.$api.removeEventListener('workflow',this.reload);
  }
  public mounted(){
    this.reload();
  }
  public reload(){    
    this.$api.execute(new Common.TaskCountQuery('PaymentTaskCountQuery', false)).then(res =>{
      var hash = res as { [key: string]: number};
      this.countReceive = hash.ReceivePayment;
      this.countSend = hash.SendPayment;
    });
  }

}
